'use client';

import { ToolsTranslations } from '@/lib/translations/types';

type Values = { revenue: number; profit: number };

interface Props {
  values: Values;
  onValuesChange: (field: keyof Values, value: number) => void;
  translations: ToolsTranslations['profitMargin'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  const handleChange = (field: keyof Values) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\s/g, '').replace(/,/g, '');
    const value = Number(raw);
    onValuesChange(field, isNaN(value) ? 0 : value);
  };

  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.revenue}</label>
        <input type="text" value={values.revenue.toLocaleString('sv-SE')} onChange={handleChange('revenue')} className={inputClass} placeholder="0" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{translations.profit}</label>
        <input type="text" value={values.profit.toLocaleString('sv-SE')} onChange={handleChange('profit')} className={inputClass} placeholder="0" />
      </div>
    </div>
  );
}


